import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-error",
  "use": "icon-error-usage",
  "viewBox": "0 0 960 960",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 960 960\" id=\"icon-error\"><g fill=\"none\" fill-rule=\"evenodd\"><circle cx=\"480\" cy=\"480\" r=\"480\" fill=\"#FF4D52\" /><circle cx=\"480\" cy=\"760\" r=\"50\" fill=\"#FFF\" /><path stroke=\"#FFF\" stroke-width=\"70\" stroke-linejoin=\"round\" stroke-linecap=\"round\" d=\"M480 160v460\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol